import './App.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import routes from './route/routes'

const roooter = createBrowserRouter(routes)

function App() {
	return (
		<RouterProvider router={roooter} />
	)
}

export default App
